query MsdkScansList(
	$runId: ConditionID!
	$totalIssuesMinFilter: ConditionInt
	$scanNameFilter: ConditionString
	$textSearch: msdk_scans_listSearchInsensitive
	$offset: Int
	$limit: Int
	$sort: msdk_scans_listSort
) {
	msdk_scans_list(
		run_id_eq: $runId
		total_issues_gt: $totalIssuesMinFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
		offset: $offset
		limit: $limit
		sort: $sort
	) {
		tenant_id
		run_id
		scan_id
		scan_name
		scan_created_at
		scan_screenshot_url
		total_issues
		critical_issues
		serious_issues
		elements_with_issues
	}

	total: msdk_scans_list(
		run_id_eq: $runId
		total_issues_gt: $totalIssuesMinFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
	) {
		total_issues
		elements_with_issues
	}
}
